import React from 'react';
import QmImage from '../../../../../components/Image/QmImage';

// styles
import qmStyles from '../../../../../theme/qmStyles';
import instructionStyles from '../Instructions.scss';
import containerStyles from './ValueProps.scss';

const ValueProps = () => (
  <div
    className={`layout-align--center-center ${
      containerStyles.valuePropContainer
    }`}
  >
    <hr style={{ width: '100%' }} />
    <h3
      className={`${instructionStyles.titleText} text-center`}
      style={{ paddingBottom: qmStyles.doubleGutter }}
    >
      With Quartermaster You Get
    </h3>
    <div className={containerStyles.valuePropRow}>
      <div className={containerStyles.valuePropColumn}>
        <QmImage
          src="static/ui/real-reviews-from-real-people.png"
          height={100}
          width={120}
        />
        <div className={containerStyles.valuePropTextContainer}>
          <h3 className={`${containerStyles.valuePropTitleText} text-center`}>
            Real Referrals From Real People
          </h3>
          <p
            className={`${
              containerStyles.valuePropDescriptionText
            } text-center`}
          >
            All referrals are by verified homeowners from jobs run on
            Quartermaster.
          </p>
        </div>
      </div>
      <div className={containerStyles.valuePropColumn}>
        <QmImage
          src="static/ui/good-neighbour-guarantee.png"
          height={100}
          width={100}
        />
        <div className={containerStyles.valuePropTextContainer}>
          <h3 className={`${containerStyles.valuePropTitleText} text-center`}>
            Our Good Neighbour Guarantee
          </h3>
          <p
            className={`${
              containerStyles.valuePropDescriptionText
            } text-center`}
          >
            All jobs are backed by our $2,500 Good Neighbour Guarantee.
          </p>
        </div>
      </div>
      <div className={containerStyles.valuePropColumn}>
        <QmImage src="static/ui/vetted-pros.png" height={100} width={100} />
        <div className={containerStyles.valuePropTextContainer}>
          <h3 className={`${containerStyles.valuePropTitleText} text-center`}>
            A Local Network of Skilled Pros
          </h3>
          <p
            className={`${
              containerStyles.valuePropDescriptionText
            } text-center`}
          >
            Every Pro has $2M+ liability insurance, up-to-date licenses & clean
            credit.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ValueProps;
